import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { PortalService } from '../../../services/portal.service';

@Component({
  selector: 'om-modal-shell',
  templateUrl: './modal-shell.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalShell {
  private readonly portal = inject(PortalService);

  readonly isOpen = input(false);
  readonly title = input('');
  readonly showHandle = input(true);

  readonly closed = output<void>();

  readonly portalRef = viewChild<ElementRef<HTMLElement>>('shellPortal');

  constructor() {
    this.portal.attach(this.portalRef, this.isOpen, inject(DestroyRef));
  }

  onClose(): void {
    this.closed.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) this.onClose();
  }
}
